const initialState = {
    counters: {},
    forceCatalogRefresh: false
};

export default initialState;
